<template>
  <div class="historical">
    <iframe
      class="content"
      :src="$route.query.type ? 'https://auth.orangebank.com.cn/#/m/cDealOne': 'https://my.orangebank.com.cn/orgLogin/hd/act/jianzb/jzbxy.html'"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if (to.query.type) {
      to.meta.hiddenHeader = true;
      to.meta.title = "平安银行电子商务支付结算服务协议";
    } else {
      to.meta.hiddenHeader = false;
      to.meta.title = "平安数字用户服务协议";
    }
    next();
  },
}
</script>
<style lang='scss' scoped>
.historical {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
.content {
  height: 100%;
  width: 100%;
}
</style>